
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.923 2L22 4.408V20.24l-6.378-1.723L9.094 22 2 19.658V4.09l6.867 1.904L15.923 2zm.154 2.194L16 4.238v12.329l4 1.08V5.75l-3.923-1.555zM10 7.634l4-2.264v11.764l-4 2.133V7.634zM8 7.81L4 6.701v11.53l4 1.32V7.81z","fill":"#4F71E8"}})])
          )
        }
      }
    